export default __webpack_public_path__ + "static/media/GM_Cup_Trippy.d3cc0fcc.png";